/*
 * @Description: 用户管理
 * @Author: wangwangwang
 * @Date: 2020-06-30 14:18:14
 * @LastEditors: hexy
 * @LastEditTime: 2023-11-03 15:17:29
 */
import request from '@/utils/request'
export const Download = "/base/system/user/export";
export const exportTemplate = "/base/system/user/exportTemplate";
export const exportTemplate2 = "/base/system/user/exportPersonalTemplate";

// 获取用户信息不包含组织
export function getUserInfoList(params) {
  return request({
    url: '/base/system/user/get_user_all_org_sign',
    method: 'get',
    params
  })
}

// 自动覆盖原有账号
export function coverUser(data) {
  return request({
    url: '/base/system/user/coverUser',
    method: 'post',
    data
  })
}
// 获取用户数据
export function queryPage(params) {
  return request({
    url: '/base/system/user/queryPage',
    method: 'post',
    data: params
  })
}

// 获取用户数据 受权限控制
export function queryUserPageByLimit(params) {
  return request({
    url: '/base/system/user/queryPageLimit',
    method: 'post',
    data: params
  })
}

// 用于角色管理
export function roleUserListByLimit(params) {
  return request({
    url: '/base/system/user/queryPageForAuthLimit',
    method: 'post',
    data: params
  })
}

// 查询角色
export function queryRole(params) {
  return request({
    url: '/base/system/data/limits/join/queryRolePermissionByUserId',
    method: 'post',
    data: params
  })
}

// 查询角色
export function queryRoleList(params) {
  return request({
    url: '/base/system/role/queryRoleList',
    method: 'post',
    data: params
  })
}

// 查询修改角色
export function getRoleList(params) {
  return request({
    url: '/base/system/role/user/get_list',
    method: 'get',
    params
  })
}

// 获取用户数据 专用权限接口
export function queryUsersByLimit(params) {
  return request({
    url: '/base/system/user/queryPageForAuthLimit',
    method: 'post',
    data: params
  })
}

// 新增、编辑用户
export function saveOrUpdate(params) {
  return request({
    url: '/base/system/user/save_or_update',
    method: 'post',
    data: params
  })
}
// 新增:客户或者供应商账号
export function saveUser(params) {
  return request({
    url: '/base//system/user/saveUser',
    method: 'post',
    data: params
  })
}

export function updateOrDelete(params) {
  return request({
    url: '/base/system/user/batch_update_or_delete',
    method: 'post',
    data: params,
  })
}
export function queryjobPage(data) {
  return request({
    url: '/base/system/base/stations/query_page',
    method: 'post',
    data
  })
}
export function updateSortNum(data) {
  return request({
    url: '/base/system/user/update_sort_num',
    method: 'post',
    data
  })
}
/**重置密码*/
export function reset_password(data) {
  return request({
    url: '/base/system/user/reset_password',
    method: 'post',
    data
  })
}
/**根据岗位id获取职级*/
export function get_list(data) {
  return request({
    url: '/base/system/base/rank/post/get_list',
    method: 'post',
    data
  })
}

//根据用户的id和type获取用户的功能、app、微信小程序权限
export function get_user_auth_source(params) {
  return request({
    url: 'base/system/user/get_user_auth_source',
    method: 'get',
    params
  })
}

//获取用户的数据左侧权限展示
export function get_user_data_source(params) {
  return request({
    url: 'base/system/user/get_user_data_source',
    method: 'get',
    params
  })
}

//根据userId和上一个接口返回的dataLimitsJoinId获取数据右侧权限
export function get_user_data_source_tables(params) {
  return request({
    url: 'base/system/user/get_user_data_source_tables',
    method: 'get',
    params
  })
}
/**
 * 
 * @returns 通过token获取用户信息
 */
export function getUserInfo() {
  return request({
    url: '/base/system/user/getUserInfoByToken',
    method: 'post'
  })
}

